interface CsrfResult {
  readonly csrfToken: string;
}

interface BeginEmailChangeResult {
  readonly expiresAt: string;
}

async function freshCsrfToken(): Promise<string> {
  const response = await fetch('/api/auth/csrf', {
    method: 'GET',
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error('csrf-unavailable');
  const result = (await response.json()) as CsrfResult;
  return result.csrfToken;
}

export async function beginEmailChange(input: {
  readonly newEmail: string;
  readonly currentPassword: string;
  readonly totpCode: string;
}): Promise<BeginEmailChangeResult> {
  const csrfToken = await freshCsrfToken();
  const response = await fetch('/api/auth/email-change', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('email-change-rejected');
  return (await response.json()) as BeginEmailChangeResult;
}

export async function completeEmailChange(input: {
  readonly currentAddressCode: string;
  readonly newAddressCode: string;
}): Promise<void> {
  const csrfToken = await freshCsrfToken();
  const response = await fetch('/api/auth/email-change/complete', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('email-change-rejected');
}
